import { getContent } from '../../../shared/content.js';
import { useHref, useLocale, useStrings } from '../../i18n.js';

/**
 * 404.
 *
 * Note what it does not say: nothing about rooms existing or not existing. A private
 * room that has expired or been deleted is served by the room application, which has its
 * own honest message. This page is only for public URLs that do not exist.
 */

export function NotFound() {
  const s = useStrings();
  const c = getContent(useLocale()).notFound;
  const href = useHref();

  return (
    <section className="section">
      <div className="section__inner section__inner--narrow prose">
        <h1 className="section__title">{c.heading}</h1>
        <p className="section__lede">{c.lede}</p>
        <div className="button-row">
          <a className="button button--primary" href={href('/')}>
            {s.states.createNew}
          </a>
          <a className="button button--secondary" href={href('/how-it-works')}>
            {s.common.navHowItWorks}
          </a>
        </div>
      </div>
    </section>
  );
}
